// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.reporting .load-card {
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.reporting__table {
  width: 100%;
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.reporting__table__extra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 12px 16px;
  min-height: 45px;
}
.reporting__table__extra-header__title .pui-headline {
  font-weight: bold;
  color: #4a4a4a;
  margin: 0;
}
.reporting__table__extra-header__toggle .pui-toggle {
  margin: 0;
}
.reporting__table__extra-header__toggle {
  display: flex;
  gap: 20px;
}
.reporting__table__extra-header__toggle__info {
  color: #adadad;
  font-size: 14px;
}
.reporting__table__extra-header__actions {
  display: flex;
  gap: 10px;
}
.reporting__table__extra-header__actions .pui-button {
  padding: 0;
}
.reporting .card-header button.btn {
  padding-left: 20px;
  cursor: default;
}
.reporting .table-scroll::-webkit-scrollbar {
  display: none;
}
.reporting .table-scroll {
  -ms-overflow-style: none;
}
.reporting .scroll-bottom-bar {
  overflow-x: scroll;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  display: flex;
  white-space: nowrap;
}
.reporting .wbs-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .country-wrapper {
  min-width: 8rem;
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .plant-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .unit-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .project-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .lump-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .aero-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .justification-wrapper {
  min-width: 33.6rem;
  max-width: 33.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .maintenance-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .outageid-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .risk-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .procurement-wrapper {
  min-width: 27.2rem;
  max-width: 27.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .comment-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .planning-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .budget-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .startdate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .enddate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .currency-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .spenduntil-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .previous-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .previousplusone-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .previousplustwo-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .previoustotal-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .forecast-wrapper {
  min-width: 16.8rem;
  max-width: 16.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .newmtpplus1-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .newmtpplus2-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .newmtpplus3-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .after-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .total-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .cr-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .fundingstatus-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .primary-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .mainflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .otherflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .review-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .priocategory-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .priorank-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .focustopics-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .created-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .createdby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .modified-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .modifiedby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .outagetype-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .header-table {
  display: flex;
  height: 48px;
  background-color: white;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.reporting .header-table.fixed-scrool-bottom {
  height: 0;
  border: none;
}
.reporting .header-table .fixed-globalid {
  position: sticky;
  left: 0;
  min-width: 22.464rem;
  max-width: 22.464rem;
  background-color: white;
  border-right: none;
  padding-left: 25px;
}
.reporting .header-table .fixed-globalid .checkmark {
  top: 13px;
}
.reporting .header-table .fixed-name {
  position: sticky;
  left: 22.464rem;
  min-width: 41.6rem;
  max-width: 41.6rem;
  background-color: white;
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991px) {
.reporting .header-table .fixed-globalid {
    position: relative;
    left: 0;
    min-width: 19.2rem;
    max-width: 19.2rem;
    background-color: white;
    border-right: none;
    padding-left: 25px;
}
.reporting .header-table .fixed-globalid .checkmark {
    top: 13px;
}
.reporting .header-table .fixed-name {
    position: relative;
    left: 0;
    min-width: 22.48rem;
    background-color: white;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    box-shadow: none;
}
}
@media (max-width: 767px) {
.reporting .header-table .fixed-name {
    min-width: 19.28rem;
}
}
.reporting .header-table div {
  padding: 10px;
  border-right: 1px solid #d4d4d4;
}
.reporting .header-table-wrapper {
  position: sticky;
  top: 90px;
  z-index: 2;
}
.reporting .subtitle-menu {
  width: 100%;
  background-color: #f9f9f9;
  padding: 5px 15px;
  font-size: 17px;
}
.reporting .export {
  text-align: right;
  min-width: 130px;
}
.reporting .export .fa-icon {
  margin-right: 8px;
}
.reporting .mtp-select {
  width: 300px;
}
.reporting .multiselect-menu .fa-icon {
  float: right;
  top: -4px;
  right: -5px;
  position: relative;
}
.reporting .multiselect-menu .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
  border: none;
  color: #007bff;
  background-color: transparent;
}
.reporting .multiselect-menu .section-button .btn:nth-child(2) {
  position: relative;
  right: 0;
}
.reporting .multiselect-menu .section-button {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.reporting .multiselect-menu .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.reporting .multiselect-menu .dropdown-menu.show {
  overflow-y: auto;
  max-height: 400px;
}
@media (max-width: 767px) {
.reporting .multiselect-menu .dropdown-menu.show {
    max-height: 280px;
}
}
.reporting .multiselect-menu .sticky-position {
  position: sticky;
  bottom: 0;
}
.reporting .multiselect-menu .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
}
.reporting .multiselect-menu .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.reporting .multiselect-menu .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px;
  min-height: 38px;
  white-space: nowrap;
  box-shadow: none !important;
  text-align: left;
}
.reporting .multiselect-menu .custom-button {
  width: 100%;
}
.reporting .multiselect-menu {
  /* Hide the browser's default checkbox */
}
.reporting .multiselect-menu .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.reporting .multiselect-menu {
  /* Create a custom checkbox */
}
.reporting .multiselect-menu .checkmark {
  position: absolute;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
  top: unset;
  margin-top: -8px;
}
.reporting .multiselect-menu {
  /* When the checkbox is checked, add a blue background */
}
.reporting .multiselect-menu .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.reporting .multiselect-menu {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.reporting .multiselect-menu .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.reporting .multiselect-menu {
  /* Show the checkmark when checked */
}
.reporting .multiselect-menu .container input:checked ~ .checkmark:after {
  display: block;
}
.reporting .multiselect-menu {
  /* Style the checkmark/indicator */
}
.reporting .multiselect-menu .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.reporting .multiselect-menu .btn {
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.4rem;
}
.reporting .multiselect-menu label.container {
  max-width: 0;
}
.reporting .accordion-reporting {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 100px;
}
.reporting .accordion-reporting .dropright:hover > .dropdown-menu {
  display: block;
}
.reporting .accordion-reporting .section-checked ~ .header-table-wrapper {
  position: sticky;
  top: 195px;
  z-index: 2;
}
.reporting .accordion-reporting .table-scroll::-webkit-scrollbar {
  display: none;
}
.reporting .accordion-reporting .table-scroll {
  -ms-overflow-style: none;
}
.reporting .accordion-reporting .header-table-scroll-sync::-webkit-scrollbar {
  display: none;
}
.reporting .accordion-reporting .header-table-scroll-sync {
  -ms-overflow-style: none;
}
.reporting .accordion-reporting .scroll-bottom-bar {
  overflow-x: scroll;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  display: flex;
  white-space: nowrap;
}
.reporting .accordion-reporting .local-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .cr-id-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .wbs-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .country-wrapper {
  min-width: 8rem;
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .plant-group-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .plant-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .unit-wrapper {
  min-width: 25.6rem;
  max-width: 25.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .project-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .lump-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .aero-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .justification-wrapper {
  min-width: 33.6rem;
  max-width: 33.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .maintenance-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .outageid-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .risk-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .procurement-wrapper {
  min-width: 27.2rem;
  max-width: 27.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .comment-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .planning-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .budget-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .startdate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .enddate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .currency-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .spenduntil-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .previous-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .previousplusone-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .previousplustwo-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .previoustotal-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .forecast-wrapper {
  min-width: 16.8rem;
  max-width: 16.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .forecasteur-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus1-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus1eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus2-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus2eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus3-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .newmtpplus3eur-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .uel-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .after-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .total-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .fundingstatus-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .primary-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .mainflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .otherflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .review-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .priocategory-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .priorank-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .focustopics-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .created-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .createdby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .modified-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .modifiedby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .outagetype-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .header-table {
  display: flex;
  height: 48px;
  background-color: white;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.reporting .accordion-reporting .header-table.fixed-scrool-bottom {
  height: 0;
  border: none;
}
.reporting .accordion-reporting .header-table .fixed-globalid {
  position: sticky;
  left: 0;
  min-width: 22.544rem;
  max-width: 22.544rem;
  background-color: white;
  border-right: none;
  padding-left: 25px;
}
.reporting .accordion-reporting .header-table .fixed-globalid .checkmark {
  top: 13px;
}
.reporting .accordion-reporting .header-table .fixed-name {
  position: sticky;
  left: 22.544rem;
  min-width: 41.6rem;
  max-width: 41.6rem;
  background-color: white;
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991px) {
.reporting .accordion-reporting .header-table .fixed-globalid {
    position: relative;
    left: 0;
    min-width: 19.2rem;
    max-width: 19.2rem;
    background-color: white;
    border-right: none;
    padding-left: 25px;
}
.reporting .accordion-reporting .header-table .fixed-globalid .checkmark {
    top: 13px;
}
.reporting .accordion-reporting .header-table .fixed-name {
    position: relative;
    left: 0;
    min-width: 22.48rem;
    background-color: white;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    box-shadow: none;
}
}
@media (max-width: 767px) {
.reporting .accordion-reporting .header-table .fixed-name {
    min-width: 19.28rem;
}
}
.reporting .accordion-reporting .header-table div {
  padding: 10px;
  border-right: 1px solid #d4d4d4;
}
.reporting .accordion-reporting .header-table-wrapper {
  position: sticky;
  top: 90px;
  z-index: 2;
}
.reporting .accordion-reporting .icon-dropdown {
  position: absolute;
  margin-top: 4px;
}
.reporting .accordion-reporting .box {
  width: 14px;
  height: 14px;
  display: inline-block;
  top: 1px;
  border-radius: 15px;
  margin-right: 10px;
  position: relative;
}
.reporting .accordion-reporting .fix .dropright .dropdown-toggle::after {
  vertical-align: 0;
  margin-left: 10px;
}
.reporting .accordion-reporting table .fix button span {
  padding-left: 25px;
}
.reporting .accordion-reporting .fix .dropdown-item:disabled {
  opacity: 50%;
}
.reporting .accordion-reporting .showingBR {
  display: inline-block;
  padding-left: 10px;
}
.reporting .accordion-reporting table tr > td:nth-child(1) {
  text-align: start;
}
.reporting .accordion-reporting table .dropdown-item button span {
  margin-left: 10px;
}
.reporting .accordion-reporting .multiselect {
  min-width: 150px;
}
.reporting .accordion-reporting .itemsChecked {
  background-color: #bad8f1 !important;
}
.reporting .accordion-reporting .itemsChecked td {
  background-color: #bad8f1 !important;
}
.reporting .accordion-reporting #dropdownMenuLink {
  position: absolute;
}
.reporting .accordion-reporting label.container {
  max-width: 0;
}
.reporting .accordion-reporting {
  /* Hide the browser's default checkbox */
}
.reporting .accordion-reporting #readyForApproval input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}
.reporting .accordion-reporting #readyForApproval span {
  margin-top: 10px;
  color: #007bff;
  background-color: transparent;
  border: 1px solid #ADADAD;
  margin-right: 5px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.6rem 1.2rem;
  font-size: 1.6rem;
  line-height: 1.5;
  border-radius: 0.4rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.reporting .accordion-reporting #readyForApproval label {
  margin-bottom: 0;
  cursor: pointer;
}
.reporting .accordion-reporting #readyForApproval input:checked + span {
  background: #0062cc;
  color: #fff;
}
.reporting .accordion-reporting {
  /* Hide the browser's default checkbox */
}
.reporting .accordion-reporting .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.reporting .accordion-reporting {
  /* Create a custom checkbox */
}
.reporting .accordion-reporting .checkmark {
  position: absolute;
  top: 15px;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
.reporting .accordion-reporting {
  /* When the checkbox is checked, add a blue background */
}
.reporting .accordion-reporting .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.reporting .accordion-reporting {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.reporting .accordion-reporting .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.reporting .accordion-reporting {
  /* Show the checkmark when checked */
}
.reporting .accordion-reporting .container input:checked ~ .checkmark:after {
  display: block;
}
.reporting .accordion-reporting {
  /* Style the checkmark/indicator */
}
.reporting .accordion-reporting .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.reporting .accordion-reporting .btn {
  background-color: transparent;
}
.reporting .accordion-reporting .fix input {
  margin-right: 10px;
  margin-left: 5px;
}
.reporting .accordion-reporting .fix:nth-child(1) {
  left: 15px;
  position: absolute;
  width: 22.4rem;
  border-right: 0;
  border-left: 1px solid #d4d4d4;
  padding-left: 25px;
}
.reporting .accordion-reporting .collapsing .fix:nth-child(1) {
  left: 0;
}
.reporting .accordion-reporting .fix:nth-child(2) {
  left: 24rem;
  position: absolute;
  width: 41.6rem;
  border-left: 1px solid #d4d4d4;
  padding-right: 2px;
}
.reporting .accordion-reporting .fix:nth-child(2) div {
  overflow: hidden;
  text-overflow: ellipsis;
}
.reporting .accordion-reporting .collapsing .fix:nth-child(2) {
  left: 22.48rem;
}
.reporting .accordion-reporting tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.reporting .accordion-reporting tr:last-child td {
  border-bottom: 1px solid #d4d4d4;
}
.reporting .accordion-reporting table {
  width: 100%;
  margin-left: 64rem;
  overflow-y: visible;
  padding-bottom: 1px;
  display: block;
}
.reporting .accordion-reporting button:focus {
  box-shadow: none;
}
.reporting .accordion-reporting h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
}
.reporting .accordion-reporting .table th {
  border-bottom: 1px solid #dee2e6;
}
.reporting .accordion-reporting .table tr:first-child td:first-child {
  border-top: 1px solid transparent;
}
.reporting .accordion-reporting .table tr:first-child td:nth-child(2) {
  border-top: 1px solid transparent;
}
.reporting .accordion-reporting .active {
  color: #0078dc;
}
.reporting .accordion-reporting .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.reporting .accordion-reporting .number ~ .third-number {
  padding-left: 0;
  padding-right: 5px;
}
.reporting .accordion-reporting .arrow {
  cursor: pointer;
  position: relative;
  top: -0.5px;
}
.reporting .accordion-reporting .table th,
.reporting .accordion-reporting .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: white;
}
.reporting .accordion-reporting .table td .btn {
  font-weight: bold;
  padding: 0;
  right: 13px;
  top: 8px;
}
@media (max-width: 991px) {
.reporting .accordion-reporting .table td .btn {
    padding-left: 7px;
}
}
.reporting .accordion-reporting .table {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.reporting .accordion-reporting .btn-clear {
  color: #007bff;
}
.reporting .accordion-reporting .button-acc {
  background-color: #f3f5f7;
  padding: 37px 15px 18px;
  display: flex;
  flex-wrap: wrap;
}
.reporting .accordion-reporting .button-acc .select {
  min-width: unset;
}
.reporting .accordion-reporting .button-acc button {
  margin-top: 10px;
}
.reporting .accordion-reporting .button-acc input {
  margin-top: 10px;
}
.reporting .accordion-reporting .button-acc svg {
  position: absolute;
  right: 20px;
  margin-top: 12px;
  top: 5px;
  color: #ADADAD;
  transform: rotate(90deg);
  pointer-events: none;
}
.reporting .accordion-reporting .button-acc svg.search-icon {
  pointer-events: all;
  cursor: pointer;
}
.reporting .accordion-reporting .button-acc svg.icon-times {
  pointer-events: all;
  cursor: pointer;
  right: 45px;
  height: 1.2em;
  top: 3px;
}
.reporting .accordion-reporting .button-acc .checkmark {
  top: unset;
  margin-top: -6px;
}
.reporting .accordion-reporting .button-acc .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
}
.reporting .accordion-reporting .button-acc .section-button .btn:nth-child(2) {
  position: absolute;
  right: 16px;
}
.reporting .accordion-reporting .button-acc .section-button {
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.reporting .accordion-reporting .button-acc .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.reporting .accordion-reporting .button-acc .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
}
.reporting .accordion-reporting .button-acc .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.reporting .accordion-reporting .button-acc .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  white-space: nowrap;
}
.reporting .accordion-reporting .button-acc .btn-primary:hover {
  color: #fff;
  background-color: #0069d9;
  border-color: #0062cc;
}
.reporting .accordion-reporting .section-checked {
  background-color: #0078dc;
  height: 105px;
  align-items: center;
  position: sticky;
  top: 90px;
  z-index: 2;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.reporting .accordion-reporting .section-checked .col a {
  margin-left: 25px;
}
@media (max-width: 768px) {
.reporting .accordion-reporting .section-checked .col a {
    margin-left: 6px;
}
}
.reporting .accordion-reporting .section-checked .icon-cancel {
  padding-right: 5px;
  position: relative;
  font-size: 16px;
}
.reporting .accordion-reporting .section-checked .btn {
  color: #007bff;
}
.reporting .accordion-reporting .btn-primary {
  background-color: transparent;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #007bff;
  margin-right: 5px;
}
.reporting .accordion-reporting .select {
  background-color: #fff;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #212529;
  padding-right: 65px;
  padding-left: 15px;
}
.reporting .accordion-reporting .select::placeholder {
  color: #ADADAD;
}
.reporting .accordion-reporting tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
@media (min-width: 991px) {
.reporting .accordion-reporting tbody tr td:nth-child(2):after {
    content: " ";
    display: block;
    position: absolute;
    top: 0px;
    width: 3px;
    right: 1px;
    height: 48px;
    -moz-box-shadow: 0px 0px 3px #d1d571;
    box-shadow: 5px 0px 3px rgba(0, 0, 0, 0.1);
}
.reporting .accordion-reporting thead tr th:nth-child(2) {
    border-top-right-radius: 6px;
    box-shadow: 2px 0px 4px rgba(0, 0, 0, 0.1);
}
}
.reporting .accordion-reporting .Blue td:first-child {
  box-shadow: inset 12px 0px 0px -5px #607d8b;
}
.reporting .accordion-reporting .Red td:first-child {
  box-shadow: inset 12px 0px 0px -5px #f50057;
}
.reporting .accordion-reporting .Grey td:first-child {
  box-shadow: inset 12px 0 0px -5px #d6d6d6;
}
.reporting .accordion-reporting .card-body {
  padding: 35px 15px;
  padding-bottom: 10px;
  padding-top: 0;
}
.reporting .accordion-reporting .card-body:first-child {
  padding-bottom: 0;
}
.reporting .accordion-reporting .search-form {
  float: right;
}
@media (min-width: 991px) {
.reporting .accordion-reporting .fixed-name {
    border-top-right-radius: 6px;
}
}
@media (max-width: 991px) {
.reporting .accordion-reporting table {
    margin-left: 0 !important;
    font-size: 1.44rem;
    padding-bottom: 0;
}
.reporting .accordion-reporting table.table th {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.reporting .accordion-reporting table.table td {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.reporting .accordion-reporting table th.fix:nth-child(1) {
    display: table-cell;
    min-width: 19.2rem;
    max-width: 19.2rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.reporting .accordion-reporting table th.fix:nth-child(2) {
    display: table-cell;
    width: 22.4rem;
    position: relative;
    left: 0;
    right: 0;
}
.reporting .accordion-reporting table td.fix:nth-child(1) {
    display: table-cell;
    min-width: 19.2rem;
    max-width: 19.2rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.reporting .accordion-reporting table td.fix:nth-child(2) {
    display: block;
    position: relative;
    left: 0;
    right: 0;
    width: 22.4rem;
    border-bottom: none;
    min-width: 150px;
}
.reporting .accordion-reporting table td.fix:nth-child(2) div {
    width: 100%;
}
}
@media (max-width: 991px) and (max-width: 767px) {
.reporting .accordion-reporting table td.fix:nth-child(2) {
    width: 19.2rem;
}
}
@media (max-width: 991px) {
.reporting .accordion-reporting table.table td .btn {
    right: 10px;
    top: 5px;
}
.reporting .accordion-reporting table tr:last-child td {
    border-bottom: none;
}
.reporting .accordion-reporting .search-form {
    float: none;
}
.reporting .accordion-reporting .search-form .input-group {
    width: 100%;
}
.reporting .accordion-reporting .form-inline.nav-selectors {
    margin: 0 auto;
    width: 100%;
}
.reporting .accordion-reporting .button-acc {
    padding-top: 15px;
}
.reporting .accordion-reporting .button-acc .btn {
    margin-bottom: 5px;
}
}
@media (max-width: 767px) {
.reporting .accordion-reporting .button-acc .btn-filter {
    width: 100%;
    max-width: none;
    font-size: 1.44rem;
}
.reporting .accordion-reporting #readyForApproval label {
    width: 100%;
}
.reporting .accordion-reporting #readyForApproval label span {
    width: 100%;
    font-size: 1.44rem;
}
}
@media (max-width: 575px) {
.reporting .accordion-reporting .dropdown-menu.style-dropdown-filter {
    font-size: 12px;
    max-width: 180px;
}
.reporting .accordion-reporting .dropdown-menu.style-dropdown-filter label {
    overflow: hidden;
    text-overflow: ellipsis;
}
.reporting .accordion-reporting .showingBR {
    display: block;
    padding-left: 0;
}
.reporting .accordion-reporting .dropright .dropdown-menu {
    top: 30px;
    left: 30%;
}
.reporting .accordion-reporting .element-number {
    font-size: 1.28rem;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
